import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";
import {Dialog} from "primereact/dialog";

import _FM_FolioListComponent from "../components/_FM_folio/_FM_FolioListComponent";
import _FM_FolioFormComponent from "../components/_FM_folio/_FM_FolioFormComponent";
import _FM_FolioShowComponent from "../components/_FM_folio/_FM_FolioShowComponent";
import _FM_ReservationShowComponent from "../components/_FM_reservation/_FM_ReservationShowComponent";
import _FM_ReservationFormComponent from "../components/_FM_reservation/_FM_ReservationFormComponent";
import _FM_CustomerShowComponent from "../components/_FM_customer/_FM_CustomerShowComponent";
import _FM_ReservationgroupShowComponent from "../components/_FM_reservationgroup/_FM_ReservationgroupShowComponent";
import _FM_FolioDndComponent from "../components/_FM_folio/_FM_FolioDndComponent";
import _FM_ReceiptFormComponent from "../components/_FM_receipt/_FM_ReceiptFormComponent";
import _FM_ReceiptShowComponent from "../components/_FM_receipt/_FM_ReceiptShowComponent";
import {Message} from "primereact/message";
import HelpComponent from "../components/HelpComponent";
import _FM_CustomerFormComponent from "../components/_FM_customer/_FM_CustomerFormComponent";

const _FM_FolioPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();
  useEffect(() => {
    document.title = t('folio') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/folio');
  }, []);

  useEffect(() => {
    if (action === 'update' && entity === 'reservation') {
      window.App.help('/reservation')
    }
  }, [action, entity]);

  return (
    <div className="_FM_FolioPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/folio"}/>
      <Panel>
        <_FM_FolioListComponent/>
      </Panel>
      <Sidebar position="right" visible={!entity && (action === 'create' || action === 'update')} closeOnEscape={true}
               style={{width: '90%', maxWidth: '1200px'}}
               onHide={() => {
                 navigate(-1);
               }}>
        <_FM_FolioFormComponent/>
      </Sidebar>
      <Sidebar position="right" visible={!entity && action === 'read'} closeOnEscape={true}
               style={{width: '90%', maxWidth: '1200px'}}
               onHide={() => {
                 navigate(-1);
               }}>
        <_FM_FolioShowComponent/>
      </Sidebar>
      <Sidebar position="right" visible={!entity && action === 'manage'} closeOnEscape={true}
               style={{width: '99%'}}
               onHide={() => {
                 if(entity === 'folio') {
                   navigate('/folio');
                 } else {
                   navigate(-1);
                 }
               }}>
        <_FM_FolioDndComponent/>
      </Sidebar>
      <Sidebar position="right" visible={action === 'read' && entity === 'reservation-group'} closeOnEscape={true}
               style={{width: '90%', maxWidth: '1200px'}}
               onHide={() => {
                 navigate(-1);
               }}>
        <_FM_ReservationgroupShowComponent backlink={'/folio'}/>
      </Sidebar>
      <Sidebar position="right" visible={action === 'read' && entity === 'reservation'} closeOnEscape={true}
               style={{width: '90%', maxWidth: '1200px'}}
               onHide={() => {
                 navigate(-1);
               }}>
        <_FM_ReservationShowComponent backlink={'/folio'}/>
      </Sidebar>
      <Sidebar position="right" visible={action === 'update' && entity === 'reservation'} closeOnEscape={true}
               style={{width: '90%', maxWidth: '1200px'}}
               onHide={() => {
                 navigate(-1);
               }}>
        <_FM_ReservationFormComponent backlink={'/folio'}/>
      </Sidebar>
      <Sidebar position="right" visible={action === 'read' && entity === 'customer'} closeOnEscape={true}
               style={{width: '90%', maxWidth: '1200px'}}
               onHide={() => {
                 navigate(-1);
               }}>
        <_FM_CustomerShowComponent backlink={'/folio'}/>
      </Sidebar>
      <Dialog header={t('new_receipt')} visible={window.App.urlVars().create === 'invoice'}
              style={{width: '99%'}}
              onHide={() => {
                navigate(-1)
              }} modal={false} draggable={false}>
        <_FM_ReceiptFormComponent />
      </Dialog>
      <Dialog header={t('new_receipt')} visible={window.App.urlVars().read === 'invoice'}
              style={{width: '99%'}}
              onHide={() => {
                navigate(-1)
              }} modal={false} draggable={false}>
        <_FM_ReceiptShowComponent />
      </Dialog>

      <Dialog visible={window.App.urlVars().update === 'customer'}
              header={t('customer')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info" text={t("dialog_movable")} /></React.Fragment>}
              onHide={() => {
                navigate(-1);
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_CustomerFormComponent customerId={window.App.urlVars().customerId} />
      </Dialog>
      <Dialog visible={window.App.urlVars().read === 'reservationGroup'}
              header={t('reservation_group')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info" text={t("dialog_movable")} /></React.Fragment>}
              onHide={() => {
                navigate(-1);
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_ReservationgroupShowComponent reservationGroupId={window.App.urlVars().reservationGroupId} />
      </Dialog>


    </div>
  )
}
export default withTranslation('common')(_FM_FolioPage);
